module.exports = __webpack_public_path__ + "static/img/helh321.3885394.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helh321.png
// module id = YcJR
// module chunks = 5